import Axios from "axios";

import {
    adminAttendanceInfo,
    adminMakeAttendance,
    adminDeleteAttendance,
    testAttData,
} from "../../api";

import {
    ADMIN_ATTENDANCE_INFO,
    CLEAR_ADMIN_ATTENDANCE_DATA,
    GET_ATT_TEST_MSG,
} from "../../mutation-types";

const state = {
    attendanceInfo: {},
    attMsg: {},
};

const getters = {
    getAttandanceData(state) {
        return state.attendanceInfo;
    },
    getAttMsg(state) {
        return state.attMsg;
    },
};

const mutations = {
    [ADMIN_ATTENDANCE_INFO](state, result) {
        state.attendanceInfo = result;
    },
    [CLEAR_ADMIN_ATTENDANCE_DATA](state) {
        state.attendanceInfo = {};
    },
    [GET_ATT_TEST_MSG](state, result) {
        state.attMsg = result;
    }
};

const actions = {
    searchAttendanceInfo({ commit }, searchParam) {
        return new Promise(function (resolve, reject) {
            commit("SET_LOADING", {
                color: "primary"
            }); // loading Opening
            Axios.get(adminAttendanceInfo, {
                params: searchParam
            })
                .then(function (response) {
                    commit("UNSET_LOADING"); // loading Closing
                    var result = response.data;
                    console.log("result", result);
                    commit("ADMIN_ATTENDANCE_INFO", result);
                    resolve(response.data);
                })
                .catch(function (error) {
                    commit("UNSET_LOADING"); // loading Closing
                    console.log(error);
                    reject();
                });
        });
    },

    getAttCheckRs({ commit }, searchParam) {
        return new Promise(function (resolve, reject) {
            commit("SET_LOADING", {
                color: "primary"
            });

            Axios.post(testAttData, searchParam)
                .then(function (response) {
                    commit("UNSET_LOADING");
                    const result = response.data;
                    console.log("result", result);
                    commit("GET_ATT_TEST_MSG", result);
                    resolve(response.data);
                })
                .catch(function (error) {
                    commit("UNSET_LOADING");
                    console.log(error);
                    reject(error);
                });
        });
    },

    saveAandacData({ commit }, schema) {
        let data = schema;
        return new Promise((resolve, reject) => {
            commit("SET_LOADING", {
                color: "primary"
            });
            Axios.post(adminMakeAttendance, data)
                .then(function (response) {
                    commit("UNSET_LOADING");
                    if (response.data.status === "success") {
                        commit("SET_SNACKBAR", {
                            msg: response.data.message,
                            color: "green"
                        });
                        commit("UNSET_FORMNOTIFY");
                        resolve();
                    } else {
                        commit("SET_SNACKBAR", {
                            msg: response.data.message,
                            color: "red"
                        });
                        commit("SET_FORMNOTIFY", {
                            type: "error",
                            msg: response.data.message
                        });
                        reject();
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    commit("UNSET_LOADING"); // loading Closing
                    commit("SET_SNACKBAR", {
                        msg: failedMsg,
                        color: "red"
                    });
                    reject();
                });
        });
    },

    deleteAttendanceData({ commit }, payload) {
        return new Promise((resolve, reject) => {
            commit("SET_LOADING", {
                color: "primary"
            });
            Axios.delete(adminDeleteAttendance, { params: payload })
                .then(function (response) {
                    commit("UNSET_LOADING");

                    if (response.data.status === "success") {
                        commit("SET_SNACKBAR", {
                            msg: "Attendance deleted successfully",
                            color: "green"
                        });
                        commit("CLEAR_ADMIN_ATTENDANCE_DATA");
                        resolve();
                    } else {
                        commit("SET_SNACKBAR", {
                            msg: response.data.message,
                            color: "red"
                        });
                        reject();
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    commit("UNSET_LOADING");
                    commit("SET_SNACKBAR", {
                        msg: "Failed to delete attendance",
                        color: "red"
                    });
                    reject(error);
                });
        });
    }

};



export default {
    state,
    getters,
    actions,
    mutations
};
